import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { api } from '../consts/url';
import {
  ProjectExternalCameraModel,
} from '../store/models/project-external-camera.model';

@Injectable({ providedIn: 'root' })
export class ExternalCameraService {
  private readonly http = inject(HttpClient);

  public getExternalCameraBrands(): Observable<ProjectExternalCameraModel.CameraBrand[]> {
    return this.http.get<ProjectExternalCameraModel.CameraBrand[]>(
      api.project.externalCamera.getExternalCameraBrands
    );
  }

  public getExternalCameraTypes(): Observable<string[]> {
    return this.http.get<string[]>(
      api.project.externalCamera.getExternalCameraTypes
    );
  }

  public getExternalCameras(
    page: number,
    perPage: number,
    params: ProjectExternalCameraModel.API.FilterParams | null,
  ): Observable<ProjectExternalCameraModel.API.FilteredCamerasResponse> {
    const requestParams = { size: perPage, page: page, ...params };
    return this.http.get<ProjectExternalCameraModel.API.FilteredCamerasResponse>(
      api.project.externalCamera.getExternalCameras,
      { params: requestParams }
    );
  }
}